// Scraper service to communicate with Firebase Cloud Function
// Note: The function needs to be deployed before scraping will work
// For now, we gracefully return null if the function is not available
import { fetchProductInfoFallback } from './scraperServiceFallback';

const SCRAPER_FUNCTION_URL = process.env.REACT_APP_SCRAPER_FUNCTION_URL || 
  'https://europe-west1-listyourwishes.cloudfunctions.net/scrapeProduct';

/**
 * Fetch product information from a URL
 * @param {string} url - Product URL to scrape
 * @returns {Promise<Object|null>} Product data or null if failed
 */
export const fetchProductInfo = async (url) => {
  if (!url || typeof url !== 'string') {
    return null;
  }

  // Basic URL validation
  try {
    new URL(url);
  } catch {
    return null;
  }

  try {
    const response = await fetch(SCRAPER_FUNCTION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ url }),
      signal: AbortSignal.timeout(15000) // 15 second timeout - fail fast and use fallback
    });

    if (!response.ok) {
      console.error('Scraping failed:', response.status);
      // Use fallback scraper when Cloud Function fails
      console.log('Using fallback scraper...');
      return await fetchProductInfoFallback(url);
    }

    const result = await response.json();
    
    if (result.success && result.data) {
      return result.data;
    }
    
    // Use fallback if Cloud Function returns no data
    console.log('Cloud Function returned no data, using fallback...');
    return await fetchProductInfoFallback(url);
  } catch (error) {
    console.error('Error fetching product info:', error);
    // Use fallback scraper when Cloud Function fails
    console.log('Using fallback scraper due to error...');
    return await fetchProductInfoFallback(url);
  }
};

